import { defineComponent } from 'vue'
import { humanizeUserActivity, humanizeUserActivityDescription } from '@/util/user-analytics'


export default defineComponent({
  data () {
    return {}
  },
  computed: {},
  methods: {
    getActivityTitle (activity) {
      return humanizeUserActivity(activity)
    },
    getActivityDescription (activity, user) {
      return humanizeUserActivityDescription(activity, user)
    },
  },
})
